import { useRef } from 'react';
import { mergeProps, useButton, useHover } from 'react-aria';

import { clsx } from '../../../lib/clsx';
import { Glyph } from '../Glyph';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './ContextMenuButton.module.css';

interface ContextMenuButtonProps {
  className?: string;
  isActive?: boolean;
  isOpen?: boolean;
  isDisabled?: boolean;
  onPress: (event: unknown) => void;
}

export function ContextMenuButton(props: ContextMenuButtonProps) {
  const other = {
    'aria-haspopup': 'menu' as const,
    'aria-expanded': props.isOpen,
  };

  const ref = useRef<HTMLButtonElement>(null);
  const contextMenuButtonHover = useHover({});
  const button = useButton(
    {
      ...props,
      ...other,
      onPress(event) {
        props.onPress(event);
      },
    },
    ref,
  );

  return (
    <button
      {...mergeProps(contextMenuButtonHover.hoverProps, button.buttonProps)}
      ref={ref}
      className={clsx(styles.root, props.className)}
      data-is-active={props.isActive}
      data-is-open={props.isOpen}
      data-is-hovered={contextMenuButtonHover.isHovered}
      data-is-disabled={props.isDisabled}
    >
      <Glyph
        source={glyph.core.tripleDot}
        color={'var(--module-glyph-color)'}
        size={theme.icon.size_large}
      />
    </button>
  );
}
